import React from 'react'
import './Contact.css'
import Header from '../../components/Header/Header'
import Nav from '../../components/Nav/Nav'
import Calendly from '../../components/Calendly/Calendly'
import Footer from '../../components/Footer/Footer'
import SEO from '../../components/SEO/SEO'

function Contact() {
  return (
    <div>
      <SEO
        title="Contact Symphony IT | Get Expert IT Support in the DMV Area"
        description="Contact Symphony IT for a free consultation. Call 443-252-3005 or email help-me@symphony-it.com. Professional IT services in Maryland, Virginia, and Washington DC."
        url="https://symphony-it.com/contact"
      />
      <Header />
      <Nav />
      <div className="contact-body">
     
      </div>
      <Calendly />
      <Footer/>
    </div>
  )
}

export default Contact